import { render, staticRenderFns } from "./BannerModal.vue?vue&type=template&id=48e1e578&scoped=true&"
import script from "./BannerModal.vue?vue&type=script&lang=js&"
export * from "./BannerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1e578",
  null
  
)

export default component.exports